import { apiClient } from '@/api/client'
import type { AvailableSite, ReportFrequency, ReportGroup, ReportGroupSite, StandaloneConfig } from './types'

const BASE = '/portal/admin/report-groups/api'
const CONFIG_BASE = '/portal/admin/automated-reports/api/config'

export async function fetchReportGroups(): Promise<ReportGroup[]> {
  const { data } = await apiClient.get<{ groups: ReportGroup[] }>(`${BASE}/groups`)
  return data.groups
}

export async function fetchStandaloneConfigs(): Promise<StandaloneConfig[]> {
  const { data } = await apiClient.get<{ configs: StandaloneConfig[] }>(CONFIG_BASE)
  return data.configs
}

export async function fetchGroupSites(groupId: number): Promise<ReportGroupSite[]> {
  const { data } = await apiClient.get<ReportGroup & { sites: ReportGroupSite[] }>(`${BASE}/group/${groupId}`)
  return data.sites
}

export async function fetchAvailableSites(companyId: string): Promise<AvailableSite[]> {
  const { data } = await apiClient.get<{ sites: AvailableSite[]; total: number }>(
    `${BASE}/available-sites/${companyId}`,
  )
  return data.sites
}

export async function createReportGroup(params: {
  company_id: string
  group_name: string
  frequency: ReportFrequency
  is_active?: boolean
}): Promise<ReportGroup> {
  const { data } = await apiClient.post<{ group: ReportGroup }>(`${BASE}/group`, params)
  return data.group
}

export async function updateReportGroup(
  id: number,
  params: Partial<{ group_name: string; frequency: ReportFrequency; is_active: boolean }>,
): Promise<ReportGroup> {
  const { data } = await apiClient.put<{ group: ReportGroup }>(`${BASE}/group/${id}`, params)
  return data.group
}

export async function deleteReportGroup(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/group/${id}`)
}

export async function addSiteToGroup(groupId: number, controllerId: string): Promise<void> {
  await apiClient.post(`${BASE}/group/${groupId}/sites`, { controller_id: controllerId })
}

export async function removeSiteFromGroup(groupId: number, controllerId: string): Promise<void> {
  await apiClient.delete(`${BASE}/group/${groupId}/sites/${encodeURIComponent(controllerId)}`)
}

export async function updateStandaloneConfig(
  id: number,
  params: Partial<{ frequency: ReportFrequency; is_active: boolean }>,
): Promise<StandaloneConfig> {
  const { data } = await apiClient.put<{ config: StandaloneConfig }>(`${CONFIG_BASE}/${id}`, params)
  return data.config
}
